/** @graphql cc **/

import gql from 'graphql-tag';

export const ContentTitleExternalQuery = gql`
	query ContentTitleExternalQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			title
			appearancePublished: properties(key: "content-appearance-published") {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
			emojiTitlePublished: properties(key: "emoji-title-published") {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
			properties(key: "editor") {
				nodes {
					id
					key
					value
				}
			}
			metadata {
				frontend {
					fabricEditorSupported
				}
			}
		}
	}
`;
